import React from 'react';
import { CloseIcon } from '../../../assets/icons';
import cx from 'classnames';

interface SidebarDrawerProps {
  /**
   * Header title of the Drawer
   */
  title: string;
  /**
   * Whether to show the drawer or not.
   */
  show: boolean;
  /**
   * Called when close button is clicked
   * @returns void
   */
  onClose?: () => void;
  /**
   * The position of the Sidebar Drawer (left or right)
   */
  position: 'left' | 'right' | 'middle';
  children: React.ReactNode;
  navigate?: () => void;
  buttonText?:any;
  onClick?: () => void;
  showFooter?: boolean;
  icon?:React.ReactNode;
}

const SidebarDrawer: React.FC<SidebarDrawerProps> = (props) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleClose = () => {
    setTimeout(() => {});
    setIsOpen(false);
    props.onClose && props.onClose();
  };

  React.useEffect(() => {
    setIsOpen(props.show);
  }, [props.show, props.position]);

  const handleButtonClick = () => {
    props.onClick && props.onClick();
    // Additional logic for submenu navigation
  };

  return isOpen ? (
    <>
      {/* Modal Background */}
      <div
        aria-hidden="false"
        className={cx({
          'fixed top-0 right-0 left-0 z-50 h-[200vh] overflow-y-auto overflow-x-hidden items-start flex bg-gray-900 bg-opacity-50':
            true,
          'blur-background': true,
          'justify-start': props.position === 'left',
          'justify-end': props.position === 'right',
          'justify-center': props.position === 'middle',
        })}
        
      >
        <div
          onClick={() => {}}
          className={cx({
            'relative z-50 h-140 w-full': true,
            'p-3 max-w-lg bg-white w-[95%] md:w-auto mt-3 ml-2 md:mt-0 md:ml-0  h-[160%] lg:min-h-[200%] xl:min-h-full shadow': true,
            'animate-slide-in-left': isOpen && props.position === 'left',
            'animate-slide-in-right': isOpen && props.position === 'right',
            'animate-slide-in-middle': isOpen && props.position === 'middle',
            'animate-slide-in':
              isOpen &&
              props.position !== 'left' &&
              props.position !== 'right' &&
              props.position !== 'middle',
          })}
          
        >
          {/* MODAL HEADER */}
          <div className="flex items-center justify-center p-8 px-10">
            <h3 className="text-[20px] font-medium ml-[12px] text-gray-900 text-center mx-auto ">{props.title}</h3>
            <button
              aria-label="Close"
              className=" ml-auto inline-flex items-center rounded-lg bg-transparent text-red-400 w-35 h-35"
              type="button"
              onClick={handleClose}
            >
              <CloseIcon />
            </button>
          </div>

          {/* MODAL BODY */}
          <div className="flex justify-center items-center p-4 pt-10 "> {props.icon && <div className="mr-2">{props.icon}
          </div>}
            {props.children}</div>

           {/* MODAL FOOTER */}
           {props.showFooter && (
           <div className="flex justify-end p-4">
             {props.buttonText && props.onClick && (
            <button
              className="bg-[#FF6702] text-white rounded mr-[6em] w-[215px] mt-[1em] h-[48px] flex justify-center p-4 text-[16px]"
              onClick={handleButtonClick}
            >
               {props.buttonText}
               </button>
               )}
               </div>
  )}
        </div>
      </div>
    </>
  ) : null;
};

export { SidebarDrawer };
